/**
 * Sprint T-17.1 · Notification Center · ChannelIcon.
 * §7.2 · icon lucide per channel.
 */
import React from "react";
import { Mail, Webhook, MessageSquare, MessageCircle, Bell, HelpCircle } from "lucide-react";

const ICONS = {
  email:    Mail,
  webhook:  Webhook,
  sms:      MessageSquare,
  whatsapp: MessageCircle,
  push:     Bell,
};

const COLOR = {
  email:    "text-sky-400",
  webhook:  "text-fuchsia-400",
  sms:      "text-emerald-400",
  whatsapp: "text-green-500",
  push:     "text-orange-400",
};

export default function ChannelIcon({ channel, size = 12, showLabel = false, testId }) {
  const c = (channel || "").toLowerCase();
  const Icon = ICONS[c] || HelpCircle;
  return (
    <span
      data-testid={testId || `channel-icon-${c || "unknown"}`}
      className="inline-flex items-center gap-1"
      title={c || "unknown"}
    >
      <Icon size={size} className={COLOR[c] || "text-[var(--ag-text-dim)]"} />
      {showLabel && <span className="text-[10px] uppercase tracking-wide">{c || "?"}</span>}
    </span>
  );
}

export const ALL_CHANNELS = ["email", "webhook", "sms", "whatsapp", "push"];
